/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import Modal from '@bitcoin-portal/bitcoincom-pkg-components/dist/Modal';
import QRCode from '@bitcoin-portal/bitcoincom-pkg-components/dist/QRCode';
import { handleRipple } from '../../../helpers/ripple';
import {
  Wrapper,
  Itemswrapper,
  IconImage,
  Number,
  Text,
  StyledButton,
  NumberTextWrapper,
  Mobilewrapper,
  NumberTextWrappermobile,
  StyledGatsbyLink,
} from './styled';
import {
  QrCodeWrapper,
  StyledTitle,
  StyledSubtitle,
  ModalWrapper,
} from '../../../components/QrCodeModalV2/styled';

// import StoreToggle from '../../../components/QrCodeModal/StoreToggle';

const WalletsCreated = () => {
  const modalRef = useRef();
  const { messages } = useIntl();
  const [selectedStore, setSelectedStore] = useState('GOOGLE_PLAY');

  const qrValue =
    selectedStore === 'GOOGLE_PLAY'
      ? messages['global.qrcodeModal.google-play.link']
      : messages['global.qrcodeModal.app-store.link'];

  const errvalue = messages['global.counter.value'];
  const [value, setValue] = useState(<span>{errvalue}</span>);

  const handleMobileButtonClick = e => {
    e.preventDefault();

    window.location.href = '/download';
  };

  useEffect(() => {
    const getWalletCount = async () => {
      try {
        const result = await axios.get(
          messages['global.counter.api.walletCount'],
        );
        const numWallets = result.data.totalWalletsCreated;
        const roundedNum = Math.floor(numWallets / 1000) * 1000;
        const val =
          roundedNum && typeof roundedNum === 'number' ? (
            <NumberFormat
              value={roundedNum}
              displayType="text"
              thousandSeparator
            />
          ) : (
            <span>{errvalue}</span>
          );

        setValue(val);
      } catch (error) {
        setValue(<span>{errvalue}</span>);
      }
    };

    getWalletCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Wrapper>
        <Itemswrapper>
          <IconImage
            src={messages['global.counter.icon.src']}
            alt={messages['global.counter.icon.alt']}
          />
          <NumberTextWrapper>
            <Number>{value}&nbsp;</Number>
            <Text>
              <FormattedMessage
                tagName="span"
                id="global.counter.wallets"
                values={{ value: '' }}
              />
            </Text>
          </NumberTextWrapper>
        </Itemswrapper>
        <StyledButton
          design="primary"
          onMouseEnter={handleRipple}
          onClick={() => modalRef.current.open()}
          className="ga-wallet-cta get-app-cta-button-2"
        >
          {messages['global.counter.button']}
        </StyledButton>
      </Wrapper>
      <Mobilewrapper>
        <Itemswrapper>
          <IconImage
            src={messages['global.counter.icon.src']}
            alt={messages['global.counter.icon.alt']}
          />
          <NumberTextWrappermobile>
            <Number>{value}&nbsp;</Number>
            <Text>
              <FormattedMessage
                tagName="span"
                id="global.counter.wallets"
                values={{ value: '' }}
              />
            </Text>
          </NumberTextWrappermobile>
        </Itemswrapper>
        <StyledButton
          onMouseEnter={handleRipple}
          onClick={handleMobileButtonClick}
          design="secondary"
        >
          {messages['global.counter.button']}
        </StyledButton>
      </Mobilewrapper>
      <ModalWrapper>
        <Modal ref={modalRef}>
          <StyledTitle>{messages['global.qrcodeModal.title']}</StyledTitle>
          <StyledSubtitle>
            {messages['global.qrcodeModal.description']}
          </StyledSubtitle>
          {/* <StoreToggle
            selectedStore={selectedStore}
            setSelectedStore={setSelectedStore}
          /> */}
          <QrCodeWrapper>
            <div style={{ width: '100%' }}>
              <img
                src="/images/uploads/download.png"
                alt="QR Code to download Bitcoin.com Wallet"
                style={{
                  width: '236px',
                  height: '236px',
                }}
              />
            </div>
          </QrCodeWrapper>
          <StyledGatsbyLink
            to="https://support.bitcoin.com/en/articles/12380851-how-to-scan-a-qr-code"
            target="_blank"
          >
            {messages['global.qrcodeModal.support']}
          </StyledGatsbyLink>
        </Modal>
      </ModalWrapper>
    </>
  );
};

export default WalletsCreated;
